import StaysLocation from 'components/LandingPageStaysLocation';
import PropertyViewer from 'components/LandingpagePropertyViewer';
import ChooseNeighbour from 'components/LandingPageChooseNeighbour';
import TitleSection from '../components/LandingPageTitleSection/TitleSection';
import Neighbourhood from 'components/LandingPageNeighbourhood/Neighbourhood';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import Triangle from 'components/LandingPageTriangle';
import LandingPageLayout from 'components/LandingPageLayout';
import TitleSectionOne from 'components/LandingPageTitleSection/TitleSectionOne';
import Head from 'next/head';
import React from 'react';

const TheJunction = () => {
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Featured location - The Junction</title>
        <meta
          name="description"
          content="An up-and-coming neighborhood, good for the one who loves the balance between home and fun. "
        />
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/the-junction" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Featured location - The Junction" />
        <meta
          property="og:description"
          content="An up-and-coming neighborhood, good for the one who loves the balance between home and fun. "
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="An up-and-coming neighborhood, good for the one who loves the balance between home and fun. "
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <meta name="google-site-verification" content="w6cEiCyxsJzrruZP6CzL7X8wnD7E8gMMl4q9aU0P59U" />
        <link rel="canonical" href="https://www.soulrooms.com/thejunction" />
      </Head>
      <div>
        <LandingPageLayout>
          <StaysLocation
            img={'/static/images/landingPages/TheJuction/TheJuction.png'}
            title={'THE JUNCTION'}
            location={
              <p
                className="text-[24px] leading[51px] font-normal text-capitalize  md:py-4 py-4 mt-5 mb-5 "
                style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
                Location -
                <a
                  href="https://www.google.com/maps/place/Junction+Triangle,+Toronto,+ON/@43.6588947,-79.459836,15z/data=!3m1!4b1!4m5!3m4!1s0x882b3438ef17e0f1:0xd40c7d89513dd4c6!8m2!3d43.6613564!4d-79.4492924"
                  target="_blank"
                  rel="noreferrer">
                  {' '}
                  <span className="text-decoration-underline text-[24px] leading[51px] font-normal 	" style={{ color: '#946F00' }}>
                    Dupont & Lansdowne
                  </span>
                </a>
              </p>
            }
            description={
              <p
                className="  responsiveText xl:pt-1 pb-2 xl:pl-1 text-[14px] leading-[30px] mb-5 "
                style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
                The Museum of Contemporary Art, an immaculate bicycle track, fine cafés, and finer microbreweries ensure
                you are always on a high out here. The Victorian-style townhouses are not too shabby either. Walking
                distance from Lansdowne TTC station with bus stops right across the street!
              </p>
            }
            btnTitle={'Find Properties Here'}
            href="/find-a-soulroom"
          />
          <Triangle imgSrc="/static/images/landingPages/TheJuction/triangle.png" />
          <Triangle imgSrc="/static/images/landingPages/TheJuction/timeshedule.png" />
          <TitleSectionOne
            title="DON'T LOSE YOUR SPOT IN THIS LOCATION"
            btnTxt="Book a Spot"
            bg="white"
            href="https://www.realsage.com/properties"
          />
          <PropertyViewer bg="black" title="FEATURED PROPERTY:">
            <iframe
              width="853"
              height="480"
              src="https://my.matterport.com/show/?m=SpQXkM9JFRN"
              frameBorder="0"
              allowFullScreen=""
              allow="vr"></iframe>
          </PropertyViewer>
          {/* Neighbourhood section  */}
          <Neighbourhood
            space={true}
            title="Neighbourhood Highlights"
            img1="/static/images/landingPages/TheJuction/balz.png "
            img2="/static/images/landingPages/TheJuction/sugo.png"
            img3="/static/images/landingPages/TheJuction/wine.png"
            cardTitle="Balzacs Powerhouse"
            cardSubTitle="$$"
            details="This iconic Canadian brand of cafés and coffee roasters is 
          located 150 meters from your SoulRoom. Yet somehow,
           the time taken to get that morning cup of coffee is far too long! "
            cardTitle2="Sugo"
            cardSubTitle2="$"
            details2="This Italian gem is waiting to be discovered. We think it would be
           a good idea to get to know your fellow SoulRoomers over 
           some spaghetti - that tends to stick together!"
            cardTitle3="Famous Last Words"
            cardSubTitle3="$$"
            details3="A 'literary' themed watering hole with multiple weekly events - this is the perfect place for
           a drink in the company of Toronto's most interesting people. Highly recommended by existing SoulRoomers!"
          />
          <HeadingSection title="CHOOSE FROM OTHER LOCATIONS" bgcolor="white" />
          <ChooseNeighbour
            imgsrc="/static/images/landingPages/TheJuction/torontocanada.png"
            title="Liberty Village, Toronto, Canada"
            discription="State of the art condos, located in a chic neighborhood, home to those who love to live, work, and play in the urban core of Toronto."
            reverse="false"
            href="/liberty-village"
          />
          <ChooseNeighbour
            imgsrc="/static/images/landingPages/TheJuction/winnipegcanada.png"
            title="Pembina avenue, Winnipeg, Manitoba, Canada"
            discription="Minutes away from the entrance to The University of Manitoba. A brand new building with state-of-the-art facilities that are bound to entertain students and professionals alike. "
            reverse="true"
            href="/winnipeg-soulrooms"
          />
          <ChooseNeighbour
            imgsrc="/static/images/landingPages/TheJuction/oldtoronto.png"
            title="Cabbagetown, Old Toronto, Canada"
            discription="Walking distance from Ryerson University, and the University of Toronto. This neighborhood nests a very strong sense of community and was the house of Irish immigrants from the 1840s!"
            reverse="false"
            href="/cabbagetown"
          />
          {/* TITLE SECTION  */}
          <TitleSection
            title="WANT TO KNOW MORE?"
            btnTxt="Chat with us"
            bg="black"
            hrefExt="https://www.messenger.com/login.php?next=https%3A%2F%2Fwww.messenger.com%2Ft%2F404951336769102%2F%3Fmessaging_source%3Dsource%253Apages%253Amessage_shortlink"
          />
        </LandingPageLayout>
      </div>
    </>
  );
};

export default TheJunction;
